import { useTasks } from "../Tasks";

const ProgressBar = () => {
  const { todaysTasks, completedTasks } = useTasks();

  const containerStyles = {
    height: 20,
    width: "100%",
    backgroundColor: "#eff0ef",
    borderRadius: 50,
    // margin: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${
      todaysTasks.length !== 0
        ? (completedTasks.length / todaysTasks.length) * 100
        : 0
    }%`,
    backgroundColor: "#0ABD2F",
    borderRadius: "inherit",
    textAlign: "right",
    transition: "300ms",
  };

  const textStyles = {
    margin: "20px",
  };

  return (
    <section id="progress-bar">
      <div style={containerStyles}>
        <div style={fillerStyles}></div>
      </div>
      <code style={textStyles}>
        {completedTasks.length}/{todaysTasks.length} complete
      </code>
    </section>
  );
};

export default ProgressBar;
